import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import profileImg from '../../images/profile_img.svg';
import location from '../../images/location.svg';
import noImage  from '../../images/no-image.jpeg';
import save from '../../images/save.svg'
import heart from '../../images/heart.svg'
import srk from '../../images/srk_v.svg'
import srk1 from '../../images/srk_v.jpg'
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { ASSETS_URL } from "../../constants/apiConstants";
import { Bearer_Token } from "../../constants/apiConstants";
import Header from "./header";
import Footer from "./footer";
import { Swiper, SwiperSlide } from 'swiper/react';
import dIcon from '../../images/d-icon.svg'
import { Mousewheel, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

function Home() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    const [properties,setProperties] = useState([]); 
    const [propertiesList,setPropertiesList] = useState([]); 
    const fetchProperties = ()  => {
        axios.get(API_BASE_URL+'get/home/properties?_skip=0&_limit=8',{
        headers: {
            Authorization: `Bearer ${Bearer_Token}`,
        }
        })
        .then((response) => {
            setProperties(response.data.data.pData)

            axios.get(API_BASE_URL+'get/home/properties?_skip=8&_limit=18',{
            headers: {
                Authorization: `Bearer ${Bearer_Token}`,
            }
            })
            .then((apiresponse) => {
                setPropertiesList(apiresponse.data.data)
            })
            .catch((error) => {
                console.log(error);
            })
        })
        .catch((error) => {
            console.log(error);
        })
    }

    useEffect(()=> {
        fetchProperties()
    },[]);

  return (
    <>
        <section class="grid_box">
            <div class="container">
                <div className="row align-items-center text_he_box">
                    <div className="col-md-4"><h4>All Properties</h4></div>
                    <div className="col-md-4">  <div class="searchbox d-flex"><input class="form-control" placeholder="Search All" type="text"/><button type="button"><img alt="search-icon" src="/static/media/search-icon.f9aaf195dd5c680284dafd8006f643de.svg"/></button></div></div>
                    <div className="col-md-4"> <h4 className="property-title text-end">Verified Properties</h4></div>
                </div>

                <div class="row g-5">
                    <div class="col-xxl-8 col-xl-8 col-lg-7 col-md-7 col-sm-8">
                        <div class="box_shk">
                            <div class="row g-5">
                            {properties.map((property) => (
                            <div class="col-xxl-3 col-xl-4 col-lg-4 col-sm-6">
                                <div class="feature_image"> 

                                <Swiper
                                direction={'horizontal'}
                                spaceBetween={0}
                                slidesPerView={1}
                                loop={true}
                                // onSlideChange={() => console.log('slide change')}
                                // onSwiper={(swiper) => console.log(swiper)}
                                pagination={{
                                    clickable: true,
                                }}
                                modules={[Mousewheel,Pagination]}
                                className="mySwiper"
                                speed={1000}
                                mousewheel={true}
                                >
                                {property.photos.slice(0, 3).map((image) => (
                                    <SwiperSlide>
                                        <img className="property-image" src={ASSETS_URL+"properties/media/medium/"+image} alt="" width="100%" />  
                                    </SwiperSlide>
                                ))}
                                </Swiper>
                                <span class="save"><img src={save} width="20px" alt="save"/></span>
                                <span class="profile_img"><img src={profileImg} width="30px" alt="profile_img"/></span>
                                <span class="heart"><img src={heart} width="25px" alt="heart"/></span>
                                </div>
                                <div class="text_feature">
                                <Link to={`/property/${property.id}`}><h4>{property.title}</h4></Link>
                                <span class="d-flex align-items-center">
                                    {/* <img src={location} alt="location"/>  */}
                                <p>{property.location_title}</p></span>
                                <span class="d-flex justify-content-between align-items-center"><p>{property.square_feet} sq ft</p> <p>{property.number_of_bathroom} Bathrooms</p> <p>{property.number_of_bedroom} Bedrooms</p></span>
                                </div>
                                <div class="price_box d-flex align-items-center  justify-content-between">
                                <h3>
                                { property.currency === 'AED' &&
                                    <img className="dirham-icon" src={dIcon} alt=""/> 
                                }
                                {(() => {
                                    switch (property.currency) {
                                    case "AED":   return  new Intl.NumberFormat("en-AE", {currency: "AED", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                                    case "USD": return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                                    case "GBP":  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                                    case "EUR": return new Intl.NumberFormat("en-BE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                                    case "INR": return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                                    default:      return "";
                                    }
                                })()}
                                </h3>
                                <span>SALE</span> </div>
                            </div>
                            ))}
                            </div>
                        </div>
                    </div>
                    <div class="col-xxl-4 col-xl-4 col-lg-5 col-md-5 col-sm-4 sk-pad-new">
                        <img src={srk1} alt="" width="100%" className="srk-img-new" />
                    </div>
                    <div className="row g-5">
                        {propertiesList && 
                        propertiesList.map((value) => (
                        <div class="col-xxl-2 col-xl-3 col-lg-3 col-sm-6">
                            <div class="feature_image"> 

                            <Swiper
                            direction={'horizontal'}
                            spaceBetween={0}
                            slidesPerView={1}
                            loop={true}
                            // onSlideChange={() => console.log('slide change')}
                            // onSwiper={(swiper) => console.log(swiper)}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[Mousewheel,Pagination]}
                            className="mySwiper"
                            speed={1000}
                            mousewheel={true}
                            >
                            {value.photos.slice(0, 3).map((image) => (
                                <SwiperSlide>
                                    <img className="property-image" src={ASSETS_URL+"properties/media/medium/"+image} alt="" width="100%" />  
                                </SwiperSlide>
                            ))}
                            </Swiper>
                            <span class="save"><img src={save} width="20px" alt="save"/></span>
                            <span class="profile_img"><img src={profileImg} width="30px" alt="profile_img"/></span>
                            <span class="heart"><img src={heart} width="25px" alt="heart"/></span>
                            </div>
                            <div class="text_feature">
                            <Link to={`/property/${value.id}`}><h4>{value.title}</h4></Link>
                            <span class="d-flex align-items-center">
                                {/* <img src={location} alt="location"/>  */}
                            <p>{value.location_title}</p></span>
                            <span class="d-flex justify-content-between align-items-center"><p>{value.square_feet} sq ft</p> <p>{value.number_of_bathroom} Bathrooms</p> <p>{value.number_of_bedroom} Bedrooms</p></span>
                            </div>
                            <div class="price_box d-flex align-items-center  justify-content-between">
                            <h3>
                            { value.currency === 'AED' &&
                                <img className="dirham-icon" src={dIcon} alt=""/> 
                            }
                            {(() => {
                                switch (value.currency) {
                                case "AED":   return  new Intl.NumberFormat("en-AE", {currency: "AED", maximumFractionDigits: 0 }).format(value.amount.replace(/[AED$£€₹, ]/g, ''));
                                case "USD": return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(value.amount.replace(/[AED$£€₹, ]/g, ''));
                                case "GBP":  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(value.amount.replace(/[AED$£€₹, ]/g, ''));
                                case "EUR": return new Intl.NumberFormat("en-BE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(value.amount.replace(/[AED$£€₹, ]/g, ''));
                                case "INR": return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(value.amount.replace(/[AED$£€₹, ]/g, ''));
                                default:      return "";
                                }
                            })()}
                            </h3>
                            <span>SALE</span> </div>
                        </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    </>
  );
}

export default Home;